// Runtime values from Vault take precedence over local development values.
const runtimeEnv = (typeof window !== 'undefined' && window.__ENV__) || {};
const buildTimeEnv = process.env || {};

const read = (key) => {
  const value = runtimeEnv[key];
  return value === undefined || value === '' ? buildTimeEnv[key] : value;
};

export const env = {
  title: read('REACT_APP_TITLE'),
  url: read('REACT_APP_URL_HOST'),
  node: read('REACT_APP_NODE_ENV'),
  node_env: read('REACT_APP_NODE_ENV'),
  port: read('REACT_APP_PORT'),
  analytic: read('REACT_ANALYTICS_KEY'),
  version: read('REACT_APP_VERSION'),
  google: {
    client_key: read('REACT_APP_GOOGLE_CLIENT_KEY'),
  },
  url_dev: read('REACT_APP_URL_DEV'),
  url_uat: read('REACT_APP_URL_UAT'),
  url_prd: read('REACT_APP_URL_PRD'),
  key_storage: read('REACT_APP_KEY_STORAGE') || '',
  key_hash: read('REACT_APP_KEY_HASH'),
};
